import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type UserType = 'real' | 'legal'

type State = {
  hasSejam: boolean
  sejamOtpError: boolean
  userType: UserType
}

type Actions = {
  setHasSejam: (hasSejam: boolean) => void
  setUserType: (userType: UserType) => void
  setSejamOtpError: (sejamOtpError: boolean) => void
}

export const useAuthStore = create<State & Actions>()(
  devtools((set) => ({
    hasSejam: true,
    userType: 'real',
    sejamOtpError: false,
    setHasSejam: (hasSejam: boolean) => set({ hasSejam }),
    setUserType: (userType: UserType) => set({ userType }),
    setSejamOtpError: (sejamOtpError: boolean) => set({ sejamOtpError }),
  })),
)
